import { appUser } from '@/utils'
// AppBase
export const AppMixin = {
  created() {
    // 微信初始化
    this.$store.dispatch('user/login/isWxAndJssdkConfig')
    if (appUser.userId) {
      this.$store.commit('user/login/setUser', appUser)
    }
    if (appUser.isWeixin) {
      console.log('微信环境初始化')
      this.$store.dispatch('user/login/getWXUserInfo')
    }
  }
}
